@if (user$ | async; as user) {
<div
  data-e2e="user-menu-widget"
  [atxTooltip]="accountInfo"
  [tooltipEnabled]="showAccountTooltip()"
  class="btn d-flex h-100 align-items-center pr-0"
  (click)="openUserMenu()"
>
  <atx-avatar
    class="profile-picture"
    [size]="avatarSize"
    [image]="user.imageLink"
    [fullName]="user.displayName"
    [connectionStatus]="userConnectionStatus$ | async"
  ></atx-avatar>
  @if (showAccountInHeader()) {
  <span
    class="d-none d-sm-inline ml-2 pl-1 info-wrapper"
    data-e2e="nav-user-name"
    >{{ account()?.name }}</span
  >
  } @else {
  <span
    class="d-none d-sm-inline ml-2 pl-1 info-wrapper"
    data-e2e="nav-user-name"
    >{{(user.displayName?.split(' '))?.[0]}}</span
  >
  }
  <fa-icon
    [icon]="['fas', 'angle-down']"
    class="ml-2 d-none d-sm-inline-block"
  ></fa-icon>
</div>
}

<ng-template #accountInfo>
  <epc-account-details
    class="d-inline-block account-info-tooltip"
    [account]="account()"
  >
  </epc-account-details>
</ng-template>

<atx-aside-menu
  [open]="menuOpened$ | async"
  placement="right"
  [useOverlay]="true"
  (openStateChange)="handleClose($event)"
>
  <div class="menu-content h-100" data-e2e="user-menu-container">
    <epc-menu-route-wrapper (closeClick)="handleClose(false)">
    </epc-menu-route-wrapper>
  </div>
</atx-aside-menu>
